
function check_custom(e) {
  let error = "";

  let recette = document.querySelector('input[name="properties[Recette]"]:checked').value;
  console.log(recette);
  
  let texte1 = document.getElementById("texte-1").value;
  console.log(texte1);
  
  let texte2 = document.getElementById("texte-2").value;
  console.log(texte2);

  if (texte1.length == 0) {
    error += "<p>- Vous avez oublié de remplir la 1ère ligne</p>"
  } else if (texte1.length >= 101) {
    error += "<p>- Votre 1ère ligne est trop longue</p>"
  } 

  if (texte2.length == 0) {
    error += "<p>- Vous avez oublié de remplir la 2ème ligne</p>"
  } else if (texte2.length >= 101) {
    
    error += "<p>- Votre 2ème ligne est trop longue</p>"
  } 
  
  let validation = document.getElementById("message-label").checked;
  console.log(validation);
  if (!validation) {
    error += "<p>- Vous avez oublié de cocher la case juste ci-dessus.</p>"
  }

  if (error.length > 0) {
    document.getElementById("custom-error").innerHTML = error;
    document.getElementById("custom-error").style.display = 'block';
    e.preventDefault();
    e.stopPropagation();
    return false;
  } else {
    document.getElementById("custom-error").style.display = 'none';
    document.getElementById("custom-error").innerHTML = error;
    return true;
  }
}

function show_recette() {
  document.getElementById("radio-recette-container-more-show").style.display = 'none';
  slideDown(document.getElementById("radio-recette-container-more"));
}

function hide_recette() {
  slideUp(document.getElementById("radio-recette-container-more"));
  setTimeout(() => {
    document.getElementById("radio-recette-container-more-show").style.display = 'flex';
  }, 300);
  
}

function slideUp(element, duration = 300) {
  element.style.transition = `height ${duration}ms, padding ${duration}ms, margin ${duration}ms`;
  element.style.height = element.offsetHeight + 'px';

  requestAnimationFrame(() => {
    element.style.overflow = 'hidden';
    element.style.height = 0;
    element.style.paddingTop = 0;
    element.style.paddingBottom = 0;
    element.style.marginTop = 0;
    element.style.marginBottom = 0;
  });

  setTimeout(() => {
    element.style.display = 'none';
  }, duration);
}

function slideDown(element, duration = 300) {
  element.style.removeProperty('display');
  let display = window.getComputedStyle(element).display;
  if (display === 'none') display = 'flex';
  element.style.display = display;

  const height = element.offsetHeight; // force mesure

  element.style.height = 0;
  element.style.paddingTop = 0;
  element.style.paddingBottom = 0;
  element.style.marginTop = 0;
  element.style.marginBottom = 0;
  element.style.overflow = 'hidden';
  element.style.transition = `height ${duration}ms, padding ${duration}ms, margin ${duration}ms`;

  requestAnimationFrame(() => {
    element.style.height = height + 'px';
    element.style.removeProperty('padding-top');
    element.style.removeProperty('padding-bottom');
    element.style.removeProperty('margin-top');
    element.style.removeProperty('margin-bottom');
  });

  setTimeout(() => {
    element.style.removeProperty('height');
    element.style.removeProperty('overflow');
  }, duration);
}

function setText(target) {
  const variantId = target.getAttribute('data-variant-id');
  if (variantId == "50947557949774") {
    document.getElementById("texte-1").placeholder = "Pour toi"
    document.getElementById("texte-2").placeholder = "Elise"
  } else if (variantId ==  "50947557982542") {
    document.getElementById("texte-1").placeholder = "Je t'aime"
    document.getElementById("texte-2").placeholder = "Anne-Marie"
  } else if (variantId == "50947558015310") {
    document.getElementById("texte-1").placeholder = "Je t'aime"
    document.getElementById("texte-2").placeholder = "Emilie" 
    
  } else if (variantId == "52734453514574") {
    document.getElementById("texte-1").placeholder = "Bonne fête"
    document.getElementById("texte-2").placeholder = "bisous Nathalie" 
  } else if (variantId == "52734453547342") {
    document.getElementById("texte-1").placeholder = "Bonne fête"
    document.getElementById("texte-2").placeholder = "Maman" 
  } else if (variantId == "52734453580110") {
    document.getElementById("texte-1").placeholder = "On t'aime"
    document.getElementById("texte-2").placeholder = "trooop fort" 
    
  } else if (variantId == "51094931571022") {
    document.getElementById("texte-1").placeholder = "Bonne fête"
    document.getElementById("texte-2").placeholder = "bisous Alma & Gabriel" 
  } else if (variantId == "51094931603790") {
    document.getElementById("texte-1").placeholder = "Bonne fête"
    document.getElementById("texte-2").placeholder = "Mamie"
  } else if (variantId == "51094931636558") {
    document.getElementById("texte-1").placeholder = "On t'aime"
    document.getElementById("texte-2").placeholder = "trooop fort" 
    
  } else if (variantId == "52037167579470") {
    document.getElementById("texte-1").placeholder = "Sandrine"
    document.getElementById("texte-2").placeholder = "De la part de papi et mamie" 
  } else if (variantId == "52037167612238") {
    document.getElementById("texte-1").placeholder = "Elodie"
    document.getElementById("texte-2").placeholder = "bisous de Cathy" 

  } else if (variantId == "52735807291726") {
    document.getElementById("texte-1").placeholder = "Infusion d'amour"
    document.getElementById("texte-2").placeholder = "pour toi Béa" 
  } else if (variantId == "52735807324494") {
    document.getElementById("texte-1").placeholder = "Agathe"
    document.getElementById("texte-2").placeholder = "bisous maman" 


  } else if (variantId == "52946562679118") {
    document.getElementById("texte-1").placeholder = "Merci maîtresse"
    document.getElementById("texte-2").placeholder = "Amandine" 
  } else if (variantId == "52946562711886") {
    document.getElementById("texte-1").placeholder = "La meilleur nounou"
    document.getElementById("texte-2").placeholder = "Merci pour cette année Christelle" 
    

  } else if (variantId == "54843333574990") {
    document.getElementById("texte-1").placeholder = "Nathalie"
    document.getElementById("texte-2").placeholder = "de la part de Béa" 
  } else if (variantId == "54843333607758") {
    document.getElementById("texte-1").placeholder = "Eliane"
    document.getElementById("texte-2").placeholder = "Passe de belles fêtes !" 
    

  } else {
    document.getElementById("texte-1").placeholder = "1ère ligne"
    document.getElementById("texte-2").placeholder = "2ème ligne" 
  }
}

const variantContainer = document.querySelector('.product-variant__container');
console.log(variantContainer);

if (variantContainer) {
  // Configuration du MutationObserver
  const observer = new MutationObserver((mutationsList) => {
    mutationsList.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'checked') {
        const target = mutation.target;
        if (target.checked) {
          setText(target);
        }
      }
    });
  });

  // Appliquer l'observateur à chaque bouton
  const inputs = variantContainer.querySelectorAll('input');
  console.log(inputs);
  inputs.forEach((input) => {
    observer.observe(input, { attributes: true });
  });


  document.addEventListener('DOMContentLoaded', function() {
    setText(document.querySelector('.product-variant__input:checked'))
  }, false);
  
}


